import React, { useEffect, Children } from 'react';
export function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#f8f8f8] text-[#1a1a2e] font-sans text-base leading-relaxed" data-id="element-4409">
      {/* Top Bar */}
      <div className="bg-[#1a0647] px-5 py-3 md:px-8 flex items-center gap-3" data-id="element-4410">
        <span className="font-bold text-lg text-white tracking-wide" data-id="element-4411">
          Caveo
        </span>
        <div className="w-px h-4 bg-white/25" data-id="element-4412"></div>
        <span className="text-[13px] text-white/60 tracking-widest uppercase" data-id="element-4413">
          Legal
        </span>
      </div>

      {/* Hero */}
      <div className="relative bg-gradient-to-br from-[#1a0647] via-[#2d0a7a] to-[#3a0f9e] px-5 pt-16 pb-12 md:pt-20 md:pb-16 text-center overflow-hidden" data-id="element-4414">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse at 70% 40%, rgba(133,40,226,0.35) 0%, transparent 65%), radial-gradient(ellipse at 20% 80%, rgba(1,206,209,0.12) 0%, transparent 55%)'
      }} data-id="element-4415"></div>

        <div className="relative z-10" data-id="element-4416">
          <div className="inline-block bg-[#b063ff]/20 border border-[#b063ff]/30 text-[#b063ff] text-xs font-medium tracking-widest uppercase px-4 py-1.5 rounded-full mb-5" data-id="element-4417">
            Legal &amp; Privacy
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-4" data-id="element-4418">
            Privacy Policy
          </h1>
          <p className="text-base text-white/65 max-w-lg mx-auto mb-7" data-id="element-4419">
            AppEmbrace, Inc. d/b/a Caveo — plain English, no fine print.
          </p>
          <div className="flex justify-center gap-6 flex-wrap" data-id="element-4420">
            <span className="text-[13px] text-white/50" data-id="element-4421">
              <strong className="text-white/85 font-semibold" data-id="element-4422">
                Effective:
              </strong>{' '}
              February 27, 2026
            </span>
            <span className="text-[13px] text-white/50" data-id="element-4423">
              <strong className="text-white/85 font-semibold" data-id="element-4424">
                Last Updated:
              </strong>{' '}
              February 2026
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="max-w-[820px] mx-auto px-5 md:px-6 pb-20" data-id="element-4425">
        {/* Intro */}
        <div className="bg-white border-l-4 border-[#01ced1] rounded-xl p-6 md:p-8 my-10 md:my-12 shadow-[0_2px_12px_rgba(26,6,71,0.07)]" data-id="element-4426">
          <p className="text-[#555577] text-[15px] mb-3 last:mb-0" data-id="element-4427">
            At Caveo, we believe privacy should be simple and clear. We only
            collect the minimum personal information necessary to provide our
            services, and we never sell your data. This policy explains what we
            collect, why we collect it, and how we use it when you access
            JoinCaveo.com or any Caveo product or service. We've written it in
            plain English on purpose, because that's how we do everything.
          </p>
          <p className="text-[#555577] text-[15px] mb-0" data-id="element-4428">
            Questions? Email us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-4429">
              privacy@caveohq.com
            </a>{' '}
            and a real person will respond.
          </p>
        </div>

        {/* Section 1 - Who We Are */}
        <div className="mb-12" data-id="element-4430">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4431">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4432">
              1
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4433">
              Who We Are
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5 last:mb-0" data-id="element-4434">
            Caveo is operated by AppEmbrace, Inc., a Delaware C-Corporation
            headquartered in Oakland, California. We are the operator of
            JoinCaveo.com and all related Caveo products and services.
            References to "Caveo," "we," "us," or "our" throughout this policy
            refer to AppEmbrace, Inc.
          </p>
        </div>

        {/* Section 2 - What Information We Collect */}
        <div className="mb-12" data-id="element-4435">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4436">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4437">
              2
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4438">
              What Information We Collect
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4439">
            We collect only what we need to give you a great experience.
          </p>

          <div className="my-5" data-id="element-4440">
            <h3 className="text-[15px] font-bold text-[#8528e2] mb-2.5 uppercase tracking-[0.06em]" data-id="element-4441">
              Information We May Collect
            </h3>
            <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4442">
              {['Account information: your name, email address, and login credentials.', 'Technical information: device type, operating system, and browser.', 'Usage data: completion of checklists, alerts delivered, and progress scores.', 'Behavioral data: website pages and content visited, and usage of sections of the platform, to help us improve the product and user experience.', 'Household profile information: number of family members, general age ranges, and device types, used solely to personalize your experience.', 'Payment information: processed securely by third-party providers. We do not store full payment card numbers on our servers.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4443">
                  <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4444">
                    →
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#8528e2]/5 to-[#01ced1]/5 border border-[#8528e2]/15 rounded-xl p-5 md:p-6 my-4 text-[15px] text-[#555577] leading-[1.75]" data-id="element-4445">
            <strong className="text-[#1a0647] font-semibold" data-id="element-4446">
              We do not sell your data.
            </strong>{' '}
            We do not collect or store sensitive data such as credit card
            numbers, Social Security numbers, or passwords to your external
            accounts. We do not track your activity outside of the Caveo
            platform.
          </div>
        </div>

        {/* Section 3 - How We Use Your Information */}
        <div className="mb-12" data-id="element-4447">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4448">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4449">
              3
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4450">
              How We Use Your Information
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4451">
            We use collected data to:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4452">
            {['Provide and improve our services.', 'Personalize your experience and deliver relevant security modules and recommendations.', 'Send alerts, reminders, and important updates related to your account and household security.', 'Generate anonymized, aggregate reports for product improvement.', 'Respond to your support requests and questions.', 'Process payments for subscriptions and add-on services.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4453">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4454">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-4455">
            We do not use your information for advertising, and we do not allow
            third parties to advertise through Caveo products.
          </p>
        </div>

        {/* Section 4 - Data Protection */}
        <div className="mb-12" data-id="element-4456">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4457">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4458">
              4
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4459">
              Data Protection
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4460">
            As a cybersecurity company, we hold ourselves to high standards.
            Here is what that means in practice:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4461">
            {['All personal data is encrypted in transit and at rest.', 'Access to personal data is limited to employees with a legitimate business need.', 'Vendors and service providers are required to follow strict security practices and are contractually bound to protect your data.', 'We conduct regular security reviews of our platform and infrastructure.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4462">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4463">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-4464">
            We encourage you to use a strong, unique password for your Caveo
            account and to enable Multi-Factor Authentication (MFA) when
            available.
          </p>
        </div>

        {/* Section 5 - Family Plans and Multi-User Accounts */}
        <div className="mb-12" data-id="element-4465">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4466">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4467">
              5
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4468">
              Family Plans and Multi-User Accounts
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4469">
            Caveo is designed for multi-generational families. Some plans
            include multiple users under one account. Here is how we handle
            that:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4470">
            {['Each family member has their own individual profile with their own privacy settings.', 'Sharing data with a designated Family IT Lead is always opt-in and voluntary, never automatic.', "Individual family members own their own data. No family member can access another member's data without that person's explicit consent.", 'Account administrators can view aggregate household security scores but cannot access individual activity logs or personal data without permission.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4471">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4472">
                  →
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        {/* Section 6 - Third-Party Sharing */}
        <div className="mb-12" data-id="element-4473">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4474">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4475">
              6
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4476">
              Third-Party Sharing
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4477">
            Caveo does not share personal information with third parties without
            your consent, except as required by law. Specifically:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4478">
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-4479">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4480">→</span>
              <span data-id="element-4481">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4482">
                  Service providers:
                </strong>{' '}
                We work with vendors who help us operate the platform, including
                Supabase (authentication and database), Vercel (hosting), and
                PostHog (analytics). These vendors access data only as needed
                and are contractually required to protect it.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-4483">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4484">→</span>
              <span data-id="element-4485">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4486">
                  Legal requirements:
                </strong>{' '}
                We may disclose information if required by law, court order, or
                government request, or to protect the rights, property, or
                safety of Caveo, our users, or others.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-4487">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4488">→</span>
              <span data-id="element-4489">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4490">
                  Business transfers:
                </strong>{' '}
                In the event of a merger, acquisition, or sale of assets, user
                information may be transferred. We will notify you before any
                such transfer takes effect.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4491">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4492">→</span>
              <span data-id="element-4493">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4494">
                  With your consent:
                </strong>{' '}
                We will not share your information for any other purpose without
                asking you first.
              </span>
            </li>
          </ul>
        </div>

        {/* Section 7 - Your Privacy Rights */}
        <div className="mb-12" data-id="element-4495">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4496">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4497">
              7
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4498">
              Your Privacy Rights
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4499">
            Depending on your location, you may have rights under applicable
            privacy laws such as the California Consumer Privacy Act (CCPA) or
            the General Data Protection Regulation (GDPR). These rights may
            include the ability to:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4500">
            {['Access the personal information we hold about you.', 'Correct inaccurate or incomplete information.', 'Request deletion of your personal information.', 'Restrict or object to certain uses of your data.', 'Opt out of the sale of your personal information. (Note: Caveo does not sell personal information.)', 'Non-discrimination for exercising your privacy rights.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4501">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4502">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-4503">
            To exercise any of these rights, contact us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-4504">
              privacy@caveohq.com
            </a>
            . We will respond within 45 days.
          </p>
        </div>

        {/* Section 8 - Children's Privacy */}
        <div className="mb-12" data-id="element-4505">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4506">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4507">
              8
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4508">
              Children's Privacy
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4509">
            Caveo supports multi-generational households, including older teens.
            We do not knowingly collect personal information from children under
            the age of 13 without verifiable parental consent. If a family plan
            includes a member under 13, the account holder is responsible for
            ensuring appropriate consent has been provided.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4510">
            If you believe a minor's data has been collected without proper
            consent, contact us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-4511">
              privacy@caveohq.com
            </a>{' '}
            and we will act promptly.
          </p>
        </div>

        {/* Section 9 - Cookies and Tracking */}
        <div className="mb-12" data-id="element-4512">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4513">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4514">
              9
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4515">
              Cookies and Tracking
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4516">
            We use cookies and similar technologies to keep you logged in,
            remember your preferences, and collect analytics. You can control
            cookie settings through your browser. Disabling cookies may limit
            certain functionality on the platform.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4517">
            We do not use cookies to track your activity outside of the Caveo
            platform.
          </p>
        </div>

        {/* Section 10 - Data Retention */}
        <div className="mb-12" data-id="element-4518">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4519">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4520">
              10
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4521">
              Data Retention
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4522">
            We keep your personal information only as long as necessary to
            provide our services or as required by law. If you close your
            account, we will delete or anonymize your personal data within 90
            days, unless we are legally required to retain it longer.
          </p>
        </div>

        {/* Section 11 - Affiliate Disclosure (FTC-Compliant) */}
        <div className="mb-12" data-id="element-4523">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4524">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4525">
              11
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4526">
              Affiliate Disclosure (FTC-Compliant)
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4527">
            Some recommendations on the Caveo platform may include affiliate
            links. This means Caveo may earn a commission if you purchase a
            product or service through one of those links, at no additional cost
            to you. This is disclosed in compliance with FTC guidelines.
          </p>
          <div className="bg-gradient-to-br from-[#8528e2]/5 to-[#01ced1]/5 border border-[#8528e2]/15 rounded-xl p-5 md:p-6 my-4 text-[15px] text-[#555577] leading-[1.75]" data-id="element-4528">
            <strong className="text-[#1a0647] font-semibold" data-id="element-4529">
              Our commitment to you:
            </strong>{' '}
            These commissions NEVER influence our recommendations. We repeat:
            They will NEVER influence our recommendations.
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4530">
            All suggestions are based on our independent evaluation of what we
            believe will best serve your family's needs, devices, comfort level,
            and budget. We maintain the same recommendation integrity whether or
            not an affiliate relationship exists.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4531">
            When we recommend products like a router, a service provider, or a
            password manager, it's because they represent the best solution for
            your situation, not because they offer affiliate revenue.
          </p>
        </div>

        {/* Section 12 - Changes to This Policy */}
        <div className="mb-12" data-id="element-4532">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4533">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4534">
              12
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4535">
              Changes to This Policy
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4536">
            We may update this Privacy Policy from time to time. When we do, we
            will revise the "Last Updated" date at the top of this page and, for
            significant changes, notify you by email or via an in-app
            notification. Your continued use of Caveo after changes take effect
            constitutes your acceptance of the updated policy.
          </p>
        </div>

        {/* Section 13 - Contact Us */}
        <div className="mb-12" data-id="element-4537">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4538">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4539">
              13
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4540">
              Contact Us
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-4" data-id="element-4541">
            If you have questions, concerns, or requests related to this Privacy
            Policy, please reach out:
          </p>

          <div className="bg-[#1a0647] rounded-xl p-7 md:p-10 mt-4" data-id="element-4542">
            <h3 className="text-lg font-bold text-white mb-4" data-id="element-4543">
              AppEmbrace, Inc. d/b/a Caveo
            </h3>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4544">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4545">
                Attn
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4546">
                Jason Phillips, CEO
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4547">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4548">
                Email
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4549">
                <a href="mailto:privacy@caveohq.com" className="text-[#b063ff] hover:underline" data-id="element-4550">
                  privacy@caveohq.com
                </a>
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4551">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4552">
                Website
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4553">
                <a href="https://JoinCaveo.com" className="text-[#b063ff] hover:underline" data-id="element-4554">
                  JoinCaveo.com
                </a>
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4555">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4556">
                Location
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4557">
                Oakland, California
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-[#eae6dc] text-center" data-id="element-4558">
          <p className="text-[13px] text-[#aaaaaa] leading-[1.7]" data-id="element-4559">
            &copy; 2026 AppEmbrace, Inc. d/b/a Caveo. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}